<span
  [id]="countrySelect.id + '-label'"
  class="block mb-1 text-left text-base font-semibold"
>
  {{ "COUNTRY" | translate }}@if (required) {<span aria-hidden="true">*</span>}
</span>
<mat-form-field
  class="block! w-full"
  appearance="outline"
  subscriptSizing="dynamic"
>
  <mat-select
    #countrySelect
    [aria-labelledby]="countrySelect.id + '-label'"
    [value]="value"
    [required]="required"
    [disabled]="disabled"
    (selectionChange)="valueChange.emit($event.value)"
  >
    @for (country of countries; track country.alpha2Code) {
    <mat-option [value]="country.alpha2Code">
      {{ country.name ?? country.alpha2Code }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>
